<template>
  <v-container fluid ref="refContainer" fill-height>
    <v-layout justify-start row v-resize="onResize">
      <v-flex shrink>
        <v-layout column>
          <v-flex shrink>
            <v-btn
            fab
            color="primary"
            @click="gotoProject">
              <v-icon>arrow_back</v-icon>
            </v-btn>
          </v-flex>
          <v-flex shrink>
            <v-btn
            fab
            color="primary"
            alt="Screenshot"
            @click="capture">
              <v-icon>save_alt</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex ref="screenshotContainer" class="screenshotContainer">
        <div ref="chartContainer" class="chartContainer">
          <splines-chart
          class="chart"
          :chart-layout="chartLayout"
          :survey="sourceSurvey"
          :show-debug="showDebug"
          :show-numbers="showNumbers"
          :show-area-labels="showAreaLabels"
          :show-title-label="showTitleLabel"
          :screenshot-mode="screenshotMode"
          />
        </div>
        <div ref="bannerDiv" class="bannerDiv">
          <img class="bannerImg" src="@/assets/logo_small_shot.png"/>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// @ is an alias to /src
import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions } = createNamespacedHelpers("projects");
import { mapState as mapStateVuex } from "vuex";
import SplinesChart from "@/components/SplinesChart";
import html2canvas from "html2canvas";
import { saveAs } from "file-saver";

export default {
  name: "Screenshot",

  components: {
    SplinesChart
  },

  data: () => ({
    debug: false,

    sourceSurvey: {},

    showError: false,
    errorMessage: "",

    chartLayout: {
      size: 400,
      minifiedSize: 250,
      anchorLeft: 0,
      anchorTop: 0
    },
    // chartTitle: '',
    showDebug: false,
    showNumbers: true,
    showAreaLabels: true,
    showTitleLabel: true,
    screenshotMode: true,

    isPortrait: false,

    // ROUTING
    projectId: null,
    userId: null,
    surveyIndex: null,
  }),

  computed: {
    ...mapState({
      project: state => state.project, // map `this.project` to `this.$store.state.projects.project`
      projectUsers: state => state.projectUsers // map `this.projectUsers` to `this.$store.state.projects.projectUsers`
    }),

    ...mapStateVuex('util', {
      isMobile: state => state.isMobile // map `this.isMobile` to `this.$store.state.util.isMobile`
    })
  },

  created() {
    this.projectId = this.$route.params.project;
    this.userId = this.$route.params.user;
    this.surveyIndex = this.$route.params.survey;

    Promise.resolve()
    .then(() => {
      if (!this.project) {
        // read projects from the db and store
        return this.readProjects()
        .then(() => {
          this.showError = false;
          return this.setActiveProject(this.projectId)
          // .then(() => {
          //   console.log('§§§ 3 this.project:', this.project);
          //   console.log('§§§ 3 this.projectUsers:', this.projectUsers);
          // })
        })
      }
      else {
        return Promise.resolve();
      }
    })
    .then(() => {
      const elementFound = this.projectUsers.find((element) => {
        return element.userId === this.userId;
      });
      if (elementFound) {
        // this.projectId = elementFound.projectId;
        const survey = elementFound.surveys[this.surveyIndex];
        this.sourceSurvey = survey;
      }
    })
    .catch((error) => {
      this.errorMessage = error.message;
      this.showError = true;
    })
  },

  mounted() {},

  methods: {
    ...mapActions ([
      'readProjects', // map `this.readProjects()` to `this.$store.dispatch('projects/readProjects')`
      'setActiveProject', // map `this.setActiveProject(project)` to `this.$store.dispatch('projects/setActiveProject', project)`
    ]),

    onResize() {
      const rect = this.$refs.screenshotContainer.getBoundingClientRect();
      let w = rect.width - 40;
      let h = rect.height - 84;
      this.chartLayout.size = Math.min(w, h);
    },

    capture() {
      if(!this.isPortrait) {
        const rect = this.$refs.screenshotContainer.getBoundingClientRect();
        // console.log('rect:', rect);
        const size = Math.min(rect.width, rect.height);
        const opt = {
          width: size,
          height: size,
          x: rect.x + ((rect.width - size) / 2),
          y: rect.y,
        };
        // console.log('opt:', opt);
        html2canvas(document.body, opt).then(canvas => {
          canvas.toBlob(blob => {
            saveAs(blob, `ICABody_${this.sourceSurvey.nickname}.jpg`);
          }, 'image/jpeg', 1);
        });
      }
    },

    gotoProject () {
      this.$router.push('/project/' + this.projectId);
    }

  }
};
</script>

<style scoped>/* "scoped" attribute limit the CSS to this component only */
/* .screenshotContainer {
  background-color: cadetblue;
}
.chart {
  background-color:blueviolet;
} */
svg {
  display: block;
  margin: 0 auto;
}
.bannerDiv {
  /* background-color: chocolate; */
  text-align: center;
  /* padding-left: 30px;
  padding-right: 30px; */
}
.bannerImg {
  max-width: 50%;
  /* background-color: violet; */
}
.showEl {
  display: block;
  /*opacity: 1;*/
}
.hideEl {
  display: none;
  /*opacity: 1;*/
}
</style>
